<template>
  <BFormInput
    v-bind="attrs"
    v-model="model"
    class="input-field"
    autocomplete="some_random_value"
    list="autocompleteOff"
    @keydown.enter.prevent="submitClosestForm"
  />
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";
import { BFormInput } from "bootstrap-vue-next";
const attrs = useAttrs();

// Define props
const props = defineProps({
  modelValue: { type: [String, Number], default: "" },
  submitOnEnter: { type: Boolean, default: true },
});

// Define v-model computed property
const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

// Emit events
const emit = defineEmits(["update:modelValue"]);

const submitClosestForm = (ev: KeyboardEvent) => {
  if (props.submitOnEnter) {
    const el = ev.target as HTMLInputElement | null;
    const form = el?.form;

    if (form && "requestSubmit" in form) {
      (form as HTMLFormElement).requestSubmit();
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/sass/components/InputField.scss" as *;
</style>
